import { render, staticRenderFns } from "./GlobalContextMenu.vue?vue&type=template&id=48eba902&"
import script from "./GlobalContextMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalContextMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports